import {
  AfterContentInit, AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Injector,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import * as Highcharts from 'highcharts';
import {Series, SeriesLineOptions, stockChart} from 'highcharts';
import StockModule from 'highcharts/modules/stock';
import HC_exporting from 'highcharts/modules/exporting';

import {ProjectMeasureService} from '../../../shared/services/project-measure/project-measure.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ProjectService} from '../../../shared/services/project/project.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material/dialog';
import {MatRadioButton, MatRadioChange} from '@angular/material/radio';
import {
  faBolt,
  faChartArea,
  faChartBar,
  faChartLine,
  faCheck,
  faCubes,
  faEraser,
  faExpandArrowsAlt,
  faFileExcel,
  faFileSignature,
  faImage,
  faList, faLongArrowAltRight,
  faRedoAlt,
  faSave,
  faStar,
  faSync,
  faTimes,
  faUndoAlt
} from '@fortawesome/free-solid-svg-icons';
import {AuthenticationService} from '../../../shared/services/authentication/authentication.service';
import {
  DataProcessingMeasureComponent,
  DataProcessingMeasureTypes, IDataProcessingMeasureParameters
} from '../../../shared/components/data-processing-measure/data-processing-measure.component';
import {ProjectExportCsvComponent} from '../project-export-csv/project-export-csv.component';
import {
  GraphicComponentUnit,
  GraphicComponentUnitSides,
  GraphicComponentView
} from '../../../shared/classes/graphic-component-view/graphic-component-view';
import {ModalService} from '../../../shared/services/modal/modal.service';
import {GraphicalViewListComponent} from '../../../shared/components/graphical-view-list/graphical-view-list.component';
import {AdvancedDateSettingsComponent} from '../../../shared/components/advanced-date-settings/advanced-date-settings.component';
import {ExportFileNameService} from '../../../shared/services/project-measure/export-file-name.service';
import {faClock} from '@fortawesome/free-solid-svg-icons/faClock';
import {LocalStorageViewsService} from '../../../shared/services/local-storage-views/local-storage-views.service';
import {environment} from '../../../../environments/environment';
import {LocalStorageViewsNoPersistenceService} from '../../../shared/services/local-storage-views/local-storage-views-no-persistence.service';
import {ILocalStorageViewsService} from '../../../shared/services/local-storage-views/ILocalStorageViewService';
import {MeasureInfosForSmartOffset, SeriesFormatterService} from '../../../shared/services/project-measure/series-formatter.service';
import {ProjectMeasureGraphicStateService} from '../../../shared/services/project-measure-graphic-state/project-measure-graphic-state.service';
import {GraphicUndersampling} from '../../../shared/enum/graphic-undersampling.enum';
import {Subscription} from 'rxjs';
import {State} from '../../../shared/classes/graphic-component-view/graphic-state';
import {Location} from '../../../shared/types/location.type';
import {GraphicGrouping} from '../../../shared/enum/graphic-grouping.enum';
import {MatSelectChange} from '@angular/material/select';
import {LocationDataProcessMeasure} from '../../../shared/classes/offset/LocationDataProcessMeasure';
import * as moment from 'moment';
import _ from 'lodash';
import {LocationsFormatterService} from '../../../shared/services/project-measure/locations-formatter.service';
import {HelperService} from '../../../shared/services/helper/helper.service';
import {IconService} from '../../../shared/services/icon/icon.service';

StockModule(Highcharts);
HC_exporting(Highcharts);

type ILocation = Location.clientSide;

@Component({
  selector: 'app-project-measure-graphic',
  templateUrl: './project-measure-graphic.component.html',
  styleUrls: ['./project-measure-graphic.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProjectMeasureGraphicComponent implements OnInit, AfterContentInit, AfterViewInit, OnDestroy {

  public faSave = faSave;
  public faStar = faStar;
  public faBolt = faBolt;
  public faFileExcel = faFileExcel;
  public faExpandArrowsAlt = faExpandArrowsAlt;
  public faImage = faImage;
  public faFileSignature = faFileSignature;
  public faCheck = faCheck;
  public faSync = faSync;
  public faChartArea = faChartArea;
  public faChartLine = faChartLine;
  public faChartBar = faChartBar;
  public faCubes = faCubes;
  public faEraser = faEraser;
  public faLongArrowAltRight = faLongArrowAltRight;
  public data: any = [];
  public dataAmplitude: any = [];
  public eventData: any = [];
  public chart: Highcharts.Chart;
  public turboThreshold: number = 0;
  public boostThreshold: number = 1;
  public lineWidth: number = 1;
  public showSpinner: boolean = false;
  public loaded: boolean = false;
  public minDataSize: number = 5;
  public underSampling: number = 1000;
  public showOffset: boolean = true;
  public showSms: number = 0;
  public showEvents: boolean = false;
  public opposite: boolean = true;
  public readOnly: boolean = false;
  public datePickerStart: Date = new Date();
  public datePickerEnd: Date = new Date();
  public dateStart: FormControl = new FormControl();
  public dateEnd: FormControl = new FormControl();
  public idProject: number;
  public countLocations: number = null;
  public project: any = [];
  public locationSelected: number[] = [];
  public isDynamicView: boolean = false;
  public location: any;
  public parentAndChildLocations: any[] = [];
  public multiDynamic: boolean = false;
  public alternateGridColor: string = '#F8F8F8';
  public gridLineColor: string = '#eae8e8';
  public showAxisManager: boolean = false;
  public unitCollection: GraphicComponentUnit[] = [];
  public locationDefault = [];
  public locationsNames = [];
  public chartType: any = 'line';
  public stepInChart: boolean = false;
  public serieVisible: any[] = [];
  public isFullScreen: boolean = false;
  public showAmplitude: boolean = false;
  public showThermalCorrection: boolean = false;
  public urlParameter: string;
  public thermalCorrectionAvailable: boolean = false;
  public thermalCorrectionRoute: string = 'ctherm';
  public rawRoute: string = 'chart';
  public periodsForDataGrouping: any[] = ['none', 'hour', 'day', 'week', 'month'];
  public periodSelectedForDataGrouping = GraphicGrouping.none;
  public frequencyForDataGrouping = 1;
  public allSelectedValue: boolean = true;
  public defaultDatePeriod = 1;
  // view properties
  public viewName = '';
  public viewId: number;
  public viewDescription = '';
  public viewFeatured = false;
  public viewForm: FormGroup;
  public faList = faList;
  public datStartEvent: number;
  public locationIdEvent: number;
  public faTimerClock = faClock;
  public currentIndexForLocalStoredView: number;
  public faUndoAlt = faUndoAlt;
  public faRedoAlt = faRedoAlt;
  public faTimes = faTimes;
  public viewNameToDisplay: string;
  public allowLocalStorageViewsMode = environment.enableLocalStorageViews;
  public dataProcessingMeasureTypes = DataProcessingMeasureTypes;
  private isSmartOffsetMode;
  private smartOffsetModeSubscription: Subscription;
  private locationToggledSubscription: Subscription;
  private loadGraphSubscription: Subscription;
  private persistViewSubscription: Subscription;
  private localStorageService: ILocalStorageViewsService;
  public locationTreeHeight: number;
  public thresholdActivated: boolean = false;
  public forceDynamic: boolean = false;
  public thresholdTable: LocationDataProcessMeasure[];
  public showDynFlagValue: boolean = false;
  private needAdjustChartSize: boolean = false;
  public timeZone: number = 0;

  dashStyleTypes = {
    MinLow: 'ShortDash',
    MaxLow: 'ShortDash',
    MinMedium: 'Dash',
    MaxMedium: 'Dash',
    MinHigh: 'LongDash',
    MaxHigh: 'LongDash'
  };

  @Output()
  change: EventEmitter<MatRadioChange>;
  @ViewChild('chartTarget', {read: ElementRef}) chartTarget: ElementRef;

  constructor(public iconService: IconService,
              private measureService: ProjectMeasureService,
              private projectService: ProjectService,
              private projectMeasureService: ProjectMeasureService,
              private route: ActivatedRoute,
              private router: Router,
              private toastr: ToastrService,
              private translate: TranslateService,
              public authenticationService: AuthenticationService,
              private matDialog: MatDialog,
              private modalService: ModalService,
              private exportFileNameService: ExportFileNameService,
              private injector: Injector,
              private seriesFormatterService: SeriesFormatterService,
              private state: ProjectMeasureGraphicStateService,
              private locationsFormatterService: LocationsFormatterService,
              private helperService: HelperService) {
    this.switchLocalStorageViewsMode(this.allowLocalStorageViewsMode);
    this.datePickerEnd.setUTCHours(23, 59, 59);
    this.datePickerStart = new Date(this.datePickerEnd.getFullYear(), this.datePickerEnd.getMonth() - this.defaultDatePeriod, this.datePickerEnd.getDate(), this.datePickerEnd.getHours(), this.datePickerEnd.getMinutes(), this.datePickerEnd.getSeconds());
    this.datePickerStart.setUTCHours(0, 0, 0);
  }

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.setChartSize();
  }

  ngOnInit() {
    this.state.initState();
    this.idProject = parseInt(this.route.snapshot.paramMap.get('idProject'));
    this.state.updateState({idProject: this.idProject});
    let routerUrl = this.router.url;
    this.showThermalCorrection = routerUrl.indexOf('ctherm') > -1;
    this.showEvents = routerUrl.indexOf('dyn-tag') > -1;
    this.forceDynamic = routerUrl.indexOf('dyn-data') > -1;
    if (this.forceDynamic) {
      this.underSampling = 5000000;
    }
    this.state.updateState({showThermalCorrection: this.showThermalCorrection, showEvents: this.showEvents});
    let url = '';
    if (routerUrl.indexOf(this.thermalCorrectionRoute) > -1) {
      url = routerUrl.replace('/' + this.thermalCorrectionRoute, '');
    }
    if (routerUrl.indexOf(this.rawRoute) > -1) {
      url = routerUrl.replace('/' + this.rawRoute, '');
    }
    this.urlParameter = url;
    this.smartOffsetModeSubscription = this.state.isSmartOffsetModeChecked$.subscribe(
      (state) => this.updateSmartOffsetMode(state)
    );
    this.locationToggledSubscription = this.state.locationToggled$.subscribe(
      ([locations, selected, names = []]) => {
        if (locations) {
          this.location = locations;
          this.setTreeLocationSelectedLocations();
          names.forEach(
            (name) => this.setSerieVisible(name, selected)
          );
          this.updateAxisSelection();
        }
      }
    );
    this.loadGraphSubscription = this.state.loadGraph$.subscribe(
      (reset) => {
        this.location = this.state.get('locations');
        if (reset) {
          this.resetChart();
        } else {
          this.setStaticChart();
        }
      }
    );
    this.persistViewSubscription = this.state.persistViewAfterLocationsChange$.subscribe(
      () => {
        this.location = this.state.get('locations');
        this.persistGraphicComponentView(false, true);
      }
    );
    this.setDateFromUrl();
    this.viewId = this.getViewIdFromUrl();
    if (this.viewId) {
      this.loadGraphicComponentView(this.viewId);
    }
  }

  ngAfterContentInit(): void {
    this.currentIndexForLocalStoredView = this.localStorageService.getCurrentIndex(this.idProject);
    if (this.router.url === '/chart/' + this.idProject && this.currentIndexForLocalStoredView > -1) {
      this.setViewFromLocalStorage();
    } else {
      this.dateStart.setValue(this.datePickerStart);
      this.dateEnd.setValue(this.datePickerEnd);
      this.state.updateState(this.generateCurrentGraphicComponentView());
      const isViewLoading = this.router.url.includes('view');
      const isLoadWithLocation = this.route.snapshot.paramMap.has('idLocation') && !isViewLoading;
      if ((!isViewLoading && this.currentIndexForLocalStoredView === -1) || isLoadWithLocation || this.showThermalCorrection) {
        this.initChart();
      }
      this.persistGraphicComponentView(false, true);
    }
  }

  ngAfterViewInit() {
    this.setChartSize();
  }

  ngOnDestroy() {
    if (this.smartOffsetModeSubscription) {
      this.smartOffsetModeSubscription.unsubscribe();
    }
    if (this.locationToggledSubscription) {
      this.locationToggledSubscription.unsubscribe();
    }
  }

  openViewModal(content) {
    let dateStart: Date = this.dateStart.value;
    let dateEnd: Date = this.dateEnd.value;
    this.viewForm = new FormGroup({
      name: new FormControl(this.viewNameToDisplay ? this.viewNameToDisplay : this.viewName, [Validators.required, Validators.minLength(2), Validators.maxLength(30)]),
      description: new FormControl(this.viewDescription),
      featured: new FormControl(this.viewFeatured, [Validators.required]),
      startHours: new FormControl(dateStart.getUTCHours(), [Validators.required, Validators.min(0), Validators.max(24)]),
      startMinutes: new FormControl(dateStart.getUTCMinutes(), [Validators.required, Validators.min(0), Validators.max(59)]),
      startSeconds: new FormControl(dateStart.getUTCSeconds(), [Validators.required, Validators.min(0), Validators.max(59)]),
      startMilliSeconds: new FormControl(dateStart.getUTCMilliseconds(), [Validators.required, Validators.min(0), Validators.max(999)]),
      endHours: new FormControl(dateEnd.getUTCHours(), [Validators.required, Validators.min(0), Validators.max(24)]),
      endMinutes: new FormControl(dateEnd.getUTCMinutes(), [Validators.required, Validators.min(0), Validators.max(59)]),
      endSeconds: new FormControl(dateEnd.getUTCSeconds(), [Validators.required, Validators.min(0), Validators.max(59)]),
      endMilliSeconds: new FormControl(dateStart.getUTCMilliseconds(), [Validators.required, Validators.min(0), Validators.max(999)]),
    });

    this.modalService.openNgbModal(content, {size: 'lg'});
  }

  closeViewModal() {
    this.modalService.dismissAllNgbModals();
  }

  saveView(create: boolean = true) {
    if (this.viewForm.valid) {
      this.viewName = this.viewForm.value.name;
      this.viewNameToDisplay = this.viewForm.value.name;
      this.viewDescription = this.viewForm.value.description;
      this.viewFeatured = this.viewForm.value.featured;
      let dateStart: Date = this.dateStart.value;
      let dateEnd: Date = this.dateEnd.value;
      dateStart.setUTCHours(this.viewForm.value.startHours);
      dateStart.setUTCMinutes(this.viewForm.value.startMinutes);
      dateStart.setUTCSeconds(this.viewForm.value.startSeconds);
      dateStart.setUTCMilliseconds(this.viewForm.value.startMilliSeconds);
      this.dateStart.setValue(dateStart);
      dateEnd.setUTCHours(this.viewForm.value.endHours);
      dateEnd.setUTCMinutes(this.viewForm.value.endMinutes);
      dateEnd.setUTCSeconds(this.viewForm.value.endSeconds);
      dateEnd.setUTCMilliseconds(this.viewForm.value.endMilliSeconds);
      this.dateEnd.setValue(dateEnd);
      this.modalService.dismissAllNgbModals();
      this.persistGraphicComponentView(create);
    } else {
      this.toastr.error(this.translate.instant('PLEASE_TYPE_IN_NAME'), this.translate.instant('ERROR'));
    }

  }

  getFormatedDateForModalView(date) {
    return Highcharts.dateFormat('%d/%m/%Y', date);
  }


  getViewIdFromUrl() {
    let viewId = null;
    let idsLocations = this.route.snapshot.paramMap.getAll('idLocation');
    if (idsLocations.length > 0) {
      if (idsLocations[0].indexOf('view') > -1) {
        let param = idsLocations[0];
        param = param.replace('view', '');
        viewId = parseInt(param);
      }
    }
    return viewId;
  }

  loadGraphicComponentView(viewId: number = null) {
    if (viewId !== null) {
      this.showSpinner = true;
      this.measureService.getGraphicalComponentView(viewId).subscribe(
        (graphicComponentView: GraphicComponentView) => {
          if (graphicComponentView.viewProjectId === parseInt(this.route.snapshot.paramMap.get('idProject'))) {
            this.viewNameToDisplay = graphicComponentView.viewName;
            this.setGraphicComponentView(graphicComponentView);
            this.state.setStateFromView(graphicComponentView);
            // callback ? from state update ?
            this.initChart(true, graphicComponentView.unitCollection);
            this.persistGraphicComponentView(false, true);
            this.toastr.success(this.translate.instant('VIEW_LOADED'), this.translate.instant('SUCCESS'));
          } else {
            this.toastr.error(this.translate.instant('ERROR_VIEW_NOT_CURRENT_PROJECT'), this.translate.instant('ERROR'));
            this.router.navigate(['/chart/' + parseInt(this.route.snapshot.paramMap.get('idProject'))]);
          }
        },
        error1 => {
          this.toastr.error(this.translate.instant('ERROR_VIEW_LOADED'), this.translate.instant('ERROR'));
          this.router.navigate(['/chart/' + parseInt(this.route.snapshot.paramMap.get('idProject'))]);
        });
    }
  }

  setGraphicComponentView(graphicComponentView: GraphicComponentView) {
    this.viewName = graphicComponentView.viewName;
    this.locationSelected = graphicComponentView.locationSelected;
    this.datePickerStart = new Date(graphicComponentView.datePickerStart);
    this.datePickerEnd = new Date(graphicComponentView.datePickerEnd);
    this.showAmplitude = graphicComponentView.showAmplitude;
    this.showAxisManager = graphicComponentView.showAxisManager;
    this.showEvents = graphicComponentView.showEvents;
    this.showOffset = graphicComponentView.showOffset;
    this.showSms = graphicComponentView.showSms;
    this.multiDynamic = graphicComponentView.multiDynamic;
    this.isDynamicView = graphicComponentView.isDynamicView;
    this.isFullScreen = graphicComponentView.isFullScreen;
    this.chartType = graphicComponentView.chartType;
    this.frequencyForDataGrouping = graphicComponentView.frequencyForDataGrouping;
    this.periodSelectedForDataGrouping = graphicComponentView.periodSelectedForDataGrouping;
    this.stepInChart = graphicComponentView.stepInChart;
    this.underSampling = graphicComponentView.underSampling;
    this.opposite = graphicComponentView.opposite;
    this.viewDescription = graphicComponentView.description;
    this.viewFeatured = graphicComponentView.featured;
    this.locationIdEvent = graphicComponentView.locationIdEvent;
    this.thresholdActivated = graphicComponentView.thresholdActivated;
    this.thresholdTable = graphicComponentView.thresholdTable;
    this.timeZone = graphicComponentView.timeZone;

  }

  getDateStartForGraphicalView() {
    if (!this.isDynamicView) {
      return Highcharts.dateFormat('%Y-%m-%dT%H:%M:%S.%LZ', this.dateStart.value);
    } else {
      return this.datStartEvent ? Highcharts.dateFormat('%Y-%m-%dT%H:%M:%S.000Z', this.datStartEvent) : Highcharts.dateFormat('%Y-%m-%dT%H:%M:%S.%LZ', this.dateStart.value);

    }
  }

  persistGraphicComponentView(create: boolean = true, toLocaleStorage: boolean = false) {
    const graphicComponentView = this.generateCurrentGraphicComponentView();

    if (toLocaleStorage) {
      this.sendViewToLocalStorage(graphicComponentView);
    } else {
      this.showSpinner = true;
      if (create) {
        this.measureService.postGraphicalComponentView(graphicComponentView).subscribe(
          (view: any) => {
            this.toastr.success(this.translate.instant('VIEW_CREATED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
            this.router.navigate(['/chart/' + this.idProject + '/view' + view.id]).then(() => {
              if (this.viewId) {
                if (!this.isDynamicView) {
                  this.setStaticChart();
                }
              }
              this.viewId = view.id;
            });
          },
          error1 => {
            this.showSpinner = false;
          });
      } else {
        this.measureService.putGraphicalComponentView(this.viewId, graphicComponentView).subscribe(
          (id: any) => {
            this.toastr.success(this.translate.instant('VIEW_SAVED'), this.translate.instant('SUCCESS'));
            this.showSpinner = false;
            if (!this.isDynamicView) {
              this.setStaticChart();
            }
          },
          error1 => {
            this.showSpinner = false;
          });
      }
    }
  }

  openGraphicalViewListModal() {
    const modalRef = this.modalService.openNgbModal(GraphicalViewListComponent, {size: 'lg'});
    modalRef.componentInstance.projectId = this.idProject;
  }

  showDataProcessingMeasureModal(indexModal, smartOffsetData: MeasureInfosForSmartOffset = null) {
    const data: IDataProcessingMeasureParameters = Object.assign({},
      {
        idProject: this.project.id,
        dateStart: this.dateStart.value,
        dateEnd: this.dateEnd.value,
        indexModal: indexModal,
        thresholdTable: this.thresholdTable
      }, smartOffsetData);
    const modalOpen = this.matDialog.open(DataProcessingMeasureComponent,
      {
        data,
        width: '90%',
        height: '600px'
      }
    );
    modalOpen.afterClosed()
      .subscribe(
        () => {
          this.currentIndexForLocalStoredView = this.localStorageService.getCurrentIndex(this.idProject);
          if (!this.showThermalCorrection) {
            this.getStaticData(this.dateStartForRequest(this.dateStart.value), this.dateEndForRequest(this.dateEnd.value),
              !this.isSmartOffsetMode);
          } else {
            this.getThermalCorrectionData(this.dateStartForRequest(this.dateStart.value), this.dateEndForRequest(this.dateEnd.value), true);
          }
          this.thresholdTable = [...modalOpen.componentInstance.thresholdTable || []];
          this.drawThreshold();
        }
      );
  }


  getEventFromView() {
    this.showAmplitude = false;
    this.isDynamicView = true;
    this.drawChart();
    this.setChartSize();
    this.showSpinner = true;
    let offSet = this.showOffset ? 1 : 0;
    let locations = this.multiDynamic ? this.locationSelected : [this.locationIdEvent];
    this.measureService.getMeasureDynamic(Highcharts.dateFormat('%Y-%m-%d %H:%M:%S.000', this.datePickerStart.getTime()), locations, this.locationIdEvent, offSet, this.underSampling, this.timeZone * -1).subscribe((data: any) => {
        this.toastr.success(this.translate.instant('DATA_LOADED'), this.translate.instant('SUCCESS'));
        this.feedChart(data);
      }
      ,
      error2 => {
        this.showSpinner = false;
      });
  }

  showExportCsvModal() {
    const data = {
      start_date: this.dateStart.value,
      end_date: this.dateEnd.value,
      idProject: this.idProject,
      showSms: this.showSms,
      locationSelected: this.locationSelected
    };
    this.matDialog.open(ProjectExportCsvComponent, {
      height: '90%',
      width: '95%',
      data
    });
  }


  getFrequencyForDataGrouping() {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  }

  setStepped() {
    this.stepInChart = !this.stepInChart;
    this.setStaticChart();
  }

  setMultiDynamic() {
    this.multiDynamic = !this.multiDynamic;
  }

  setStaticChart(notifyState = true) {
    if (!this.showSpinner) {
      if (this.chartType === 'column') {
        this.underSampling = GraphicUndersampling.raw;
      }
      if (notifyState) {
        this.state.updateState(this.generateCurrentGraphicComponentView());
      }
      if (!this.showThermalCorrection) {
        this.getStaticData(this.dateStartForRequest(this.dateStart.value), this.dateEndForRequest(this.dateEnd.value), false, notifyState);
      } else {
        this.getThermalCorrectionData(this.dateStartForRequest(this.dateStart.value), this.dateEndForRequest(this.dateEnd.value), false, notifyState);
      }
    }
    this.drawThreshold();
    this.showThreshold();
    if (!this.viewId) {
      this.persistGraphicComponentView(false, true);
    }
  }

  setStaticChartAndEvent() {
    this.showEvents = !this.showEvents;
    this.state.updateState({showEvents: this.showEvents});
    this.setStaticChart();
  }

  setStaticChartAndOffset() {
    this.showOffset = !this.showOffset;
    this.state.updateState({showOffset: this.showOffset});
    this.setStaticChart();
  }

  setStaticChartAndSms(item) {
    this.showSms = item.value;
    this.setStaticChart();
  }

  setThresholdChange() {
    this.thresholdActivated = !this.thresholdActivated;
    this.drawThreshold();
    this.persistGraphicComponentView(false, true);
  }

  setForceDynamic() {
    this.forceDynamic = !this.forceDynamic;
    this.setStaticChart();
  }

  setShowFlagValue() {
    this.showDynFlagValue = !this.showDynFlagValue;
    if (this.showDynFlagValue) {
      this.showEvents = true;
    }
    this.setStaticChart();
  }

  resetChart() {
    if (!this.showSpinner) {
      this.showAmplitude = false;
      this.opposite = true;
      this.showEvents = false;
      this.showOffset = true;
      this.showSms = 0;
      this.setDateFromUrl();
      this.datePickerEnd.setUTCHours(23, 59, 59);
      this.datePickerStart = new Date(this.datePickerEnd.getFullYear(), this.datePickerEnd.getMonth() - this.defaultDatePeriod, this.datePickerEnd.getDate(), this.datePickerEnd.getHours(), this.datePickerEnd.getMinutes(), this.datePickerEnd.getSeconds());
      this.datePickerStart.setUTCHours(0, 0, 0);
      this.initChart(false);
      this.persistGraphicComponentView(false, true);
      this.state.updateState(this.generateCurrentGraphicComponentView());
    }
  }

  setLocationView() {
    this.showAxisManager = !this.showAxisManager;
    this.setChartSize();
    this.persistGraphicComponentView(false, true);
  }


  invertAxis() {
    this.opposite = !this.opposite;
    this.chart.yAxis.forEach((axis: any) => {
      if (axis.options.id.indexOf('amplitude') === -1) {
        this.setAxisSide(axis.options.id, axis.opposite ? GraphicComponentUnitSides.left : GraphicComponentUnitSides.right, true);
      }
    });
    this.toastr.success(this.translate.instant('AXIS_INVERTED'), this.translate.instant('SUCCESS'));

  }

  setAxisVisibility(unit: string, visible: boolean = true) {
    this.unitCollection.forEach((location, index) => {
      if (location.unit === unit) {
        this.unitCollection[index].visible = visible;
        this.updateAxisVisibilityInChart(unit, visible);
      }
    });
    this.state.unitToogled$.next([unit, visible]);
    this.chart.series.forEach((serie: any) => {
      if (this.getUnitFromSerie(serie) === unit) {
        serie.update({
          visible: visible
        });
      }
    });
    this.toastr.success(this.translate.instant(unit) + ' ' + this.translate.instant(visible ? 'AXIS_ENABLED' : 'AXIS_DISABLED'), this.translate.instant('SUCCESS'));
    if (this.showAmplitude) {
      this.setStaticChart();
    }
  }

  onChangeSetAxisSide(event: MatRadioChange) {
    let radio: MatRadioButton = event.source;
    this.setAxisSide(radio.name, event.value);
  }


  setAxisSide(unit: string, side = GraphicComponentUnitSides.left, batch: boolean = false): void {

    this.unitCollection.forEach((location, index) => {
      if (location.unit === unit) {
        this.unitCollection[index].side = side;
      }
    });

    let axis: any = this.chart.get(unit);
    axis.update({
      alternateGridColor: this.getLeftAxisVisible(side, false),
      gridLineColor: this.getLeftAxisVisible(side, true),
      opposite: side !== 'left',
      labels: {
        align: side === 'left' ? 'right' : 'left',
        x: side !== 'left' ? 10 : -10
      }
    });

    if (!batch) {
      this.toastr.success(this.translate.instant(unit) + ' ' + this.translate.instant('AXIS_IS_NOW_ON_THE' + '_' + (side === 'right' ? 'RIGHT' : 'LEFT')), this.translate.instant('SUCCESS'));
    }
  }

  downloadChartImage(): void {
    if (this.chart) {
      const title: string = this.project.name + ' : '
        + this.dateStartForRequest(this.dateStart.value) + ' - '
        + this.dateEndForRequest(this.dateEnd.value) + ' - UTC ' + (this.timeZone > 0 ? '+' + this.timeZone : this.timeZone);

      // Désactiver navigator et scrollbar
      this.chart.update({
        navigator: { enabled: false },
        scrollbar: { enabled: false },
        exporting: { url: 'https://highcharts.osmos-group.com' }
      });

      const filename = this.exportFileNameService.getName(this.location, this.project.name);

      this.chart.exportChart({
        filename: filename,
        scale: 2,
        sourceWidth: 1200,
        sourceHeight: 600
      }, {
        title: {
          align: 'left',
          style: { fontWeight: 'bold' },
          text: title,
          x: 30
        },
        legend: {
          enabled: true,
          align: 'left',
          verticalAlign: 'bottom',
          layout: 'horizontal',
          itemHiddenStyle: { color: '#fff', display: 'none' }
        }
      });
    }
  }

  // downloadChartImage(): void {
  //
  //   if (this.chart) {
  //     let exportGraph: Highcharts.Chart = Object.assign({}, this.chart);
  //     let title: string = this.project.name + ' : '
  //       + this.dateStartForRequest(this.dateStart.value) + ' - '
  //       + this.dateEndForRequest(this.dateEnd.value) + ' - UTC ' + (this.timeZone > 0 ? '+' + this.timeZone : this.timeZone);
  //
  //     exportGraph.options.navigator.enabled = false;
  //     exportGraph.options.scrollbar.enabled = false;
  //
  //     const filename = this.exportFileNameService.getName(this.location, this.project.name);
  //     this.chart.exportChart({filename: filename, scale: 2, sourceWidth: 1200, sourceHeight: 600},
  //       {
  //         title: {
  //           align: 'left',
  //           style: {fontWeight: 'bold'},
  //           text: title,
  //           x: 30
  //         },
  //         legend: {
  //           enabled: true,
  //           align: 'left',
  //           verticalAlign: 'bottom',
  //           layout: 'horizontal',
  //           itemHiddenStyle: {color: '#fff', display: 'none'}
  //         }
  //       }
  //     );
  //   }
  // }

  fullScreen() {
    this.isFullScreen = !this.isFullScreen;
    this.setChartSize();
    this.persistGraphicComponentView(false, true);
  }

  setAmplitude() {
    this.showAmplitude = !this.showAmplitude;
    this.setStaticChart();
  }

  setDatePickerEndTime() {
    let date: number = this.dateEnd.value.format();
    let newDate: Date = new Date(date);
    newDate.setUTCHours(23, 59, 59);
    this.dateEnd.setValue(newDate);
  }

  setDatePickerStartTime() {
    let date: number = this.dateStart.value.format();
    let newDate: Date = new Date(date);
    newDate.setUTCHours(0, 0, 0);
    this.dateStart.setValue(newDate);
  }

  private setDateFromUrl() {
    let dateStart = this.route.snapshot.paramMap.get('dateStart');
    let dateEnd = this.route.snapshot.paramMap.get('dateEnd');
    if (dateStart !== null && dateEnd !== null) {
      this.datePickerStart = new Date(dateStart);
      this.datePickerEnd = new Date(dateEnd);
    }
  }

  private initChart(resetTreeLocation: boolean = true, unitCollection: any[] = []) {
    this.showSpinner = true;
    this.idProject = parseInt(this.route.snapshot.paramMap.get('idProject'));
    if (resetTreeLocation) {
      let idsLocations = this.route.snapshot.paramMap.getAll('idLocation');
      if (idsLocations.length > 0) {
        idsLocations = idsLocations[0].split(',');
        if (idsLocations[0].indexOf('view') === -1) {
          this.locationSelected = [];
          idsLocations.forEach((id) => {
            this.locationSelected.push(parseInt(id));
          });
          this.state.updateState({locationSelected: this.locationSelected});
        }
      }
    }
    this.projectService.getProject(this.idProject, 'locations').subscribe(
      (data: any) => {
        this.state.setLocationsLoadedFromServer(data.project_device_locations);
        const locations = this.state.get('locations');
        this.location = locations;
        this.setLocationName(locations);
        this.setUnitCollection(locations);
        this.project = data;
        if (this.showThermalCorrection && this.project.project_status_abo_maths && this.project.project_status_abo_maths.state === 0) {
          let routerUrl = this.router.url;
          let url = '';
          if (routerUrl.indexOf(this.thermalCorrectionRoute) > -1) {
            url = routerUrl.replace('/' + this.thermalCorrectionRoute, '');
          }
          this.router.navigate(['/' + this.rawRoute + url]);
        }
        this.thermalCorrectionAvailable = this.project.project_status_abo_maths && this.project.project_status_abo_maths.state !== 0;
        this.countLocations = data.project_device_locations.length;
        //initialisation chart
        this.dateStart = new FormControl(this.datePickerStart);
        this.dateEnd = new FormControl(this.datePickerEnd);
        // if (unitCollection.length > 0) {
        //  this.unitCollection = unitCollection;
        // }
        if (!this.isDynamicView) {
          if (!this.showThermalCorrection) {
            this.getStaticData(this.dateStartForRequest(this.dateStart.value), this.dateEndForRequest(this.dateEnd.value), false);
          } else {
            this.getThermalCorrectionData(this.dateStartForRequest(this.dateStart.value), this.dateEndForRequest(this.dateEnd.value), false);
          }
        } else {
          this.getEventFromView();
        }
        this.updateAxisSelection();
        this.drawThreshold();
        this.showThreshold();
      },
      error2 => {
        this.showSpinner = false;
      }
    );


  }

  private setLocationName(locations: ILocation[]) {
    this.locationsNames = [];
    locations.forEach(d => {
      this.locationsNames[d.id] = d.name;
      if (d.type) {
        this.locationsNames[d.id] = d.name + ' (' + this.translate.instant(d.type) + ')';
      }
      if (d.child) {
        d.child.forEach((child) => {
          this.locationsNames[child.id] = child.name;
          if (child.type) {
            this.locationsNames[child.id] = child.name + ' (' + this.translate.instant(child.type) + ')';
          }
        });
      }
    });
  }

  private setUnitCollection(locations: ILocation[], savedUnitCollection: GraphicComponentUnit[] = null) {
    this.locationDefault = this.setUnitList(locations);
    this.unitCollection = [];
    this.locationDefault.forEach((unitKey, index) => {
      let savedUnit = null;
      // this is currently not used, because we update the axis list according to the locations selected for consistency
      if (savedUnitCollection) {
        savedUnit = savedUnitCollection.find(
          (loc) => loc.unit === unitKey
        );
      }
      this.unitCollection.push(savedUnit ? savedUnit : new GraphicComponentUnit(unitKey, index, this.showThermalCorrection));
    });
  }


  private setUnitList(locations: ILocation[]) {
    const pushTypeOrUnit = (location: ILocation) => {
      if (location.type) {
        unitAndTypeRaw = unitAndTypeRaw.concat(!freeUnitArray.includes(location.type) ? location.type : location.unit.map(u => u.unit));
      }
    };

    let unitAndTypeRaw = [];
    let unitArray = [];

    let freeUnitArray = ['ext_v5', 'v_sensor', 'g_sensor'];
    locations.forEach(location => {
      pushTypeOrUnit(location);
      if (location.child) {
        location.child.forEach((childLocation) => pushTypeOrUnit(childLocation));
      }
    });
    unitAndTypeRaw = Array.from(new Set(unitAndTypeRaw));

    unitAndTypeRaw.forEach((type) => {
      if (type !== undefined) {
        if (type === 'liris_v2' || type === 'liris_v3' || type === 'ext_v3') {
          unitArray.push('MICRODEF');
          if (this.showThermalCorrection) {
            unitArray.push('MICRODEFCT');
          }
          unitArray.push('TEMPERATURE');
        } else if (type === 'exteg' || type === 'expe') {
          unitArray.push('MILLIMETER');
          unitArray.push('TEMPERATURE');
        } else if (type === 'inclinobiaxis_v2') {
          unitArray.push('RADIAN-X');
          unitArray.push('RADIAN-Y');
          unitArray.push('TEMPERATURE');
        } else if (type === 'inclino_v2' || type === 'inclino_v3') {
          unitArray.push('RADIAN');
          unitArray.push('TEMPERATURE');
        } else if (type === 'optic_v5') {
          unitArray.push('MICRODEF');
          if (this.showThermalCorrection) {
            unitArray.push('MICRODEFCT');
          }
          if (this.showThermalCorrection) {
            unitArray.push('TEMPERATURE');
          }
        } else if (type === 'pt_v5') {
          unitArray.push('TEMPERATURE');
        } else {
          unitArray.push(type);
          if (this.showThermalCorrection) {
            unitArray.push(type + 'CT');
          }
          if (this.showThermalCorrection) {
            unitArray.push('TEMPERATURE');
          }
        }
      }
    });
    unitArray = Array.from(new Set(unitArray));
    return unitArray.filter(
      (unit) => unit
    );
  }

  private setSerieVisible(name: string, visible: boolean) {

    let serie: any = this.chart.get(name);

    if (serie !== undefined) {
      let axisName = this.getUnitFromSerie(serie);
      let axis: any = this.chart.get(axisName);
      serie.setVisible(visible);
      if (this.showEvents || this.isSmartOffsetMode) {
        let flagserie: any = this.chart.get(name + '_flags');
        flagserie.setVisible(visible);
      }
      this.drawThreshold();
    }
  }

  private dateStartForRequest(date): string {
    this.dateStart.setValue(new Date(date));
    return Highcharts.dateFormat('%Y-%m-%d %H:%M:%S.000Z', date);
  }

  private dateEndForRequest(date): string {
    this.dateEnd.setValue(new Date(date));
    return Highcharts.dateFormat('%Y-%m-%d %H:%M:%S.000Z', date);
  }

  private getThermalCorrectionData(start: string, end: string, update = false, notifyState = true) {
    this.isDynamicView = false;
    if (this.locationSelected.length > 0) {
      let offSet = this.showOffset ? 1 : 0;
      let event = this.showEvents ? 1 : 0;
      this.showSpinner = true;
      if (!update) {
        this.drawChart();
      }
      this.setChartSize();
      this.measureService.getMeasureThermalCorrection(start, end, this.locationSelected, this.underSampling, this.timeZone * -1).subscribe((data: any) => {
          if (!update) {
            this.toastr.success(this.translate.instant('DATA_LOADED'), this.translate.instant('SUCCESS'));
          }
          this.feedChart(data, update, notifyState);
        }
        ,
        error2 => {
          this.showSpinner = false;
        });
    } else {
      this.loaded = true;
      this.showSpinner = false;
      this.drawChart();
    }
  }


  private getDynamicData(d, unit, locationId, update = false) {
    this.datStartEvent = d[unit][0];
    this.locationIdEvent = locationId;
    this.showAmplitude = false;
    if (!parseInt(d[unit][2])) {
      this.isDynamicView = true;
      if (!update) {
        this.drawChart();
      }
      this.showSpinner = true;
      let offSet = this.showOffset ? 1 : 0;
      let locations = this.multiDynamic ? this.locationSelected : [locationId];
      this.measureService.getMeasureDynamic(Highcharts.dateFormat('%Y-%m-%d %H:%M:%S.000', d[unit][0]), locations, locationId, offSet, this.underSampling, this.timeZone * -1).subscribe((data: any) => {
          if (!update) {
            this.toastr.success(this.translate.instant('DATA_LOADED'), this.translate.instant('SUCCESS'));
          }
          this.feedChart(data, update);
        }
        ,
        error2 => {
          this.showSpinner = false;
        });
    } else {
      this.getStaticData(this.dateStartForRequest(d[unit][0]), this.dateEndForRequest(d[unit][0] + (d[unit][2] * 3600 * 1000)));
    }
  }


  private getStaticData(start: string, end: string, update = false, notifyState = true) {
    this.isDynamicView = false;
    if (this.locationSelected.length > 0) {
      const offSet = this.showOffset ? 1 : 0;
      const sms = this.showSms;
      const event = this.showEvents ? 1 : 0;
      const forceDyn = this.forceDynamic ? 1 : 0;
      this.showSpinner = true;
      if (!update) {
        this.drawChart();
      }
      this.setChartSize();
      this.measureService.getMeasureStatic(start, end, this.locationSelected, event, offSet, this.underSampling, sms, forceDyn, this.timeZone * -1).subscribe((data: any) => {
          if (!update) {
            this.toastr.success(this.translate.instant('DATA_LOADED'), this.translate.instant('SUCCESS'));
          }
          this.feedChart(data, update, notifyState);
        }
        ,
        error2 => {
          this.showSpinner = false;
        });
    } else {
      this.loaded = true;
      this.showSpinner = false;
      this.drawChart();
    }
  }

  private feedChart(data, update = false, notifyState = true) {

    if (notifyState) {
      this.state.updateStateFromAction('newMeasures', data.measures);
    }

    this.serieVisible = this.getSerieVisibilityById();
    let unitIndex: number = 0;

    this.unitCollection.forEach((location) => {
      this.data[location.unit] = [];
      this.dataAmplitude[location.unit] = [];
      this.eventData[location.unit] = [];

      data.measures.forEach((unitData, index) => {
        if (unitData.measures
          && unitData.measures.length > 0
          && Object.keys(unitData.measures[0]).find(
            (key) => key === location.unit
          )
        ) {
          this.data[location.unit].push(this.pushSerieAndDatas(unitData, location.unit));
          if (this.showAmplitude && !update) {
            this.dataAmplitude[location.unit].push(this.pushSerieAndDatasAmplitude(unitData, location.unit, index));
          }
          if (this.showEvents && !this.isDynamicView) {
            this.eventData[location.unit].push(this.pushSerieAndDatasEvent(unitData, location.unit));
          } else if (this.isSmartOffsetMode) {
            const callback = (measureInfos: MeasureInfosForSmartOffset) =>
              this.showDataProcessingMeasureModal(this.dataProcessingMeasureTypes.offset, measureInfos);
            const data = this.seriesFormatterService.pushSerieAndDatasForSmartOffsetsMode(unitData, location.unit, callback);
            if (data) {
              this.eventData[location.unit].push(data);
            }
          }
        }
      });

      if (update) {

        let ev = 0;
        this.data[location.unit].forEach((d, index) => {
          let serie: any = this.chart.get(d.id);
          if (serie !== undefined) {
            let axisName = this.getUnitFromSerie(serie);
            let axis: any = this.chart.get(axisName);
            let visible = axis.options.visible === true ? this.serieVisible[serie.options.id] : axis.options.visible;
            if (d.data.length > this.minDataSize) {

              let dataMerged = this.mergeSeries(serie.options.data, d.data);
              serie.setData(dataMerged);
              serie.setVisible(visible);

              let ampSerie: any = this.chart.get('amp' + index);
              if (ampSerie !== undefined && this.showAmplitude) {
                ampSerie.setData(dataMerged);
                ampSerie.setVisible(true);
              }

            }
            let enventData = [];
            enventData[location.unit] = ((this.showEvents && !this.isDynamicView) || this.isSmartOffsetMode) ?
              (this.eventData[location.unit][ev] ? this.eventData[location.unit][ev].data : []) : [];
            if (((this.showEvents && !this.isDynamicView) || this.isSmartOffsetMode)) {
              let flagserie: any = this.chart.get(d.id + '_flags');
              if (flagserie !== undefined && d.data.length > this.minDataSize) {
                flagserie.setData(enventData[location.unit]);
              }
              ev++;
            }
          }
        });
      } else {
        let k = 0;
        this.data[location.unit].forEach((d) => {
          d.type = this.chartType;
          d.yAxis = location.unit;
          this.chart.addSeries(this.data[location.unit][k]);

          if (((this.showEvents && !this.isDynamicView) || this.isSmartOffsetMode)) {
            this.chart.addSeries(this.eventData[location.unit][k]);
          }
          if (this.showAmplitude) {
            if (location.unit !== 'TEMPERATURE') {
              this.chart.addSeries(this.dataAmplitude[location.unit][k]);
            }
          }
          k++;
        });
      }
      unitIndex++;
    });
    this.showSpinner = false;
    this.loaded = true;
    this.drawThreshold();
  }

  private mergeSeries(currentDatas, newDatas) {

    let newStart = newDatas[0].x;
    let newEnd = newDatas[newDatas.length - 1].x;
    let dataBeforeNew = [];
    let dataAfterNew = [];

    currentDatas.forEach((currentData) => {
      if (currentData.x < newStart) {
        dataBeforeNew.push(currentData);
      }
      if (currentData.x > newEnd) {
        dataAfterNew.push(currentData);
      }
    });

    let merged = dataBeforeNew.concat(newDatas);
    return merged.concat(dataAfterNew);
  }


  private pushSerieAndDatasEvent(datas, unit) {

    let data = [];
    datas.measures.forEach((d) => {
      if (d[unit]) {
        if (d[unit][2] !== '' && d[unit][2]) {
          const isCluster = !!parseInt(d[unit][2]);
          const eventValueFormatted = d[unit][2] + ' | ' + (Math.round(d[unit][1] * 1000)) / 1000 + ' ' + this.translate.instant(unit);
          data.push(
            {
              x: d[unit][0],
              title: isCluster || !this.showDynFlagValue ? d[unit][2] : eventValueFormatted,
              width: 50,
              tooltipTitle: eventValueFormatted,
              events: {
                click: (ev) => {
                  this.getDynamicData(d, unit, datas.location);
                }
              }
            }
          );
        }
      }
    });
    return {
      type: 'flags',
      showInLegend: false,
      allowOverlapX: true,
      tooltip: {
        shared: true,
        pointFormat: '{point.title} | <b>{point.y} ' + this.translate.instant(unit),
        valueDecimals: 3
      },
      cursor: 'pointer',
      data: data,
      id: datas.location + '_' + unit + '_flags',
      name: datas.location + '_' + unit + '_flags',
      color: this.helperService.getColor(unit, datas.location),
      onSeries: datas.location + '_' + unit,
      yAxis: unit,
      zIndex: 10000,
      boostThreshold: 1,
      showInNavigator: false,
    };
  }


  private pushSerieAndDatas(datas, unit) {
    let axis: any = this.chart.get(unit);
    let seriVisible = this.serieVisible[datas.location + '_' + unit];
    let visible = axis.options.visible === true ? seriVisible : axis.options.visible;
    let data = [];

    datas.measures.forEach((d) => {
      if (d[unit]) {
        data.push(
          {
            y: d[unit][1],
            x: d[unit][0],
          }
        );
      }
    });

    return {
      step: this.stepInChart,
      name: this.locationsNames[datas.location] + ' | ' + this.translate.instant(unit),
      tooltip: {
        valueSuffix: ' ' + this.translate.instant(unit),
        valueDecimals: 3
      },
      color: this.helperService.getColor(unit, datas.location),
      marker: {
        enabled: false
      },
      dashStyle: (unit.indexOf('CT') > -1) ? 'ShortDot' : 'solid',
      data: data,
      yAxis: unit,
      visible: visible,
      id: datas.location + '_' + unit,
      showInNavigator: true
    };
  }


  private pushSerieAndDatasAmplitude(datas, unit, index) {

    let data = [];

    datas.measures.forEach((d) => {
      if (d[unit]) {
        data.push(
          {
            y: d[unit][1],
            x: d[unit][0],
          }
        );
      }
    });

    return {
      type: 'column',
      id: 'amp' + index,
      name: 'Amplitude ' + this.locationsNames[datas.location] + ' | ' + this.translate.instant(unit),
      tooltip: {
        valueSuffix: ' ' + this.translate.instant(unit),
        valueDecimals: 3
      },
      color: this.helperService.getColor(unit, datas.location),
      marker: {
        enabled: false
      },
      data: data,
      yAxis: 'amplitude',
      visible: true,
      showInLegend: false,
      showInNavigator: false,
      dataGrouping: {
        approximation: 'high',
        forced: true,
        units: [
          ['day', [1]],
        ]
      },

    };
  }


  public setAxisMinAndMax(unit: string, max: number, min: number) {

    this.unitCollection.forEach((location, index) => {
      if (location.unit === unit) {
        this.unitCollection[index].min = min;
        this.unitCollection[index].max = max;

        let axis: any = this.chart.get(unit);
        axis.update({
          max: this.unitCollection[index].max,
          min: this.unitCollection[index].min
        });
        this.persistGraphicComponentView(false, true);
      }
    });
  }


  private getLeftAxisVisible(side, grid: boolean) {
    let leftCounter = 0;
    let rightCounter = 0;
    this.unitCollection.forEach((location) => {
      if (location.visible === true && location.side === 'left') {
        leftCounter++;
      }
      if (location.visible === true && location.side === 'right') {
        rightCounter++;
      }
    });
    if (side === 'right' && leftCounter === 0) {
      return (grid ? this.gridLineColor : this.alternateGridColor);
    }
    return side === 'left' || leftCounter < 2 ? (grid ? this.gridLineColor : this.alternateGridColor) : 'transparent';
  }


  private pushAxis(): any {
    let axis = [];

    this.unitCollection.forEach((location) => {
      if (!location.unit) {
        return;
      }
      axis.push(
        {
          id: location.unit,
          name: location.unit,
          visible: location.visible,
          min: location.min !== null ? location.min : undefined,
          max: location.max !== null ? location.max : undefined,
          crosshair: {
            snap: true,
            label: {
              enabled: true,
              format: '{value:.2f} ' + this.translate.instant(location.unit),
              backgroundColor: 'yellowgreen'
            }
          },
          showEmpty: false,
          startOnTick: false,
          endOnTick: false,
          tickAmount: 10,
          alternateGridColor: this.getLeftAxisVisible(location.side, false),
          gridLineColor: this.getLeftAxisVisible(location.side, true),
          title: {
            text: this.getTitleForChartAxis(location.unit)
          },
          height: this.showAmplitude ? '70%' : '98%',
          opposite: location.side !== 'left',
          labels: {
            align: location.side === 'left' ? 'right' : 'left',
            x: location.side !== 'left' ? 10 : -10,
            y: 4,
            format: '{value}'
          },
          resize: {
            enabled: true
          }
        }
      );

    });
    if (this.showAmplitude) {
      axis.push(
        {
          id: 'amplitude',
          name: 'amplitude',
          showEmpty: false,
          startOnTick: false,
          endOnTick: false,
          tickAmount: 5,
          title: {
            text: 'Amplitude'
          },
          top: '75%',
          height: '25%',
          opposite: false,
          labels: {
            align: 'right',
            x: 60,
            y: 4,
            format: '{value}'
          },
          resize: {
            enabled: true
          }
        }
      );
    }
    return axis;


  }

  private getOptionsChart() {
    const options: Highcharts.Options = {
      credits: {
        enabled: false
      },
      rangeSelector: {
        enabled: false,
      },
      navigation: {
        buttonOptions: {
          enabled: false
        }
      },
      navigator: {
        adaptToUpdatedData: false,
        xAxis: {
          startOnTick: true,
          endOnTick: true,
          minPadding: 0,
          maxPadding: 0,
          ordinal: false,
        },
        series: {
          type: this.chartType
        }
      },
      scrollbar: {
        liveRedraw: true,
      },
      chart: {
        type: this.chartType,
        alignTicks: true,
        animation: false,
        zoomType: 'x',
        events: {
          selection: (event: any): any => {
            if (!this.isDynamicView) {
              const dateStart = this.dateStartForRequest(event.xAxis[0].min);
              const dateEnd = this.dateEndForRequest(event.xAxis[0].max);
              this.state.updateState(this.generateCurrentGraphicComponentView());
              this.persistGraphicComponentView(false, true);
              if (!this.showThermalCorrection) {
                this.getStaticData(dateStart, dateEnd, true);
              } else {
                this.getThermalCorrectionData(dateStart, dateEnd, true);
              }
            }
          }
        }
      },
      title: {
        text: null
      },
      xAxis: {
        type: 'datetime',
        startOnTick: false,
        endOnTick: false,
        minPadding: 0,
        maxPadding: 0,
        ordinal: false,
        events: {
          setExtremes: (e: any) => {
            if (e.trigger === 'navigator' && (e.DOMEvent && e.DOMEvent.type === 'mouseup' || e.DOMEvent && e.DOMEvent.type === 'stopdrag')) {
              if (!this.isDynamicView) {
                const dateStart = this.dateStartForRequest(e.min);
                const dateEnd = this.dateEndForRequest(e.max);
                this.state.updateState(this.generateCurrentGraphicComponentView());
                if (!this.showThermalCorrection) {
                  this.getStaticData(dateStart, dateEnd, true);
                } else {
                  this.getThermalCorrectionData(dateStart, dateEnd, true);
                }
              }
            }
          }
        }
      },
      yAxis: this.pushAxis(),
      plotOptions: {
        area: this.optionsByChartType('area'),
        areaspline: this.optionsByChartType('areaspline'),
        line: this.optionsByChartType('line'),
        spline: this.optionsByChartType('spline'),
        column: this.optionsByChartType('column')
      },
      boost: {
        enabled: true,
        useGPUTranslations: true,
        seriesThreshold: 0
      },
    };

    return options;

  }

  private optionsByChartType(type: string = ''): any {
    return type !== 'column'
      ?
      {
        turboThreshold: this.turboThreshold,
        boostThreshold: this.boostThreshold,
        lineWidth: this.lineWidth,
        dataGrouping: this.getDataGrouping()
      }
      :
      {
        turboThreshold: this.turboThreshold,
        boostThreshold: this.boostThreshold,
        dataGrouping: this.getDataGrouping()
      };
  }

  private getDataGrouping(): any {

    if (this.isDynamicView) {
      return {};
    }
    return this.periodSelectedForDataGrouping !== 'none'
      ?
      {
        forced: true,
        units: [
          [this.periodSelectedForDataGrouping, [this.frequencyForDataGrouping]]
        ]
      }
      :
      {enabled: false};
  }

  private drawChart() {
    this.chart = stockChart(this.chartTarget.nativeElement, this.getOptionsChart());
    if (this.needAdjustChartSize) {
      this.setChartSize();
    }
  }

  setPeriodSelectedForDataGrouping(event: MatSelectChange) {
    this.state.updateState({dataGroupingPeriod: event.value});
    this.setStaticChart();
  }

  setTimeZone(event: MatSelectChange) {
    this.timeZone = event.value;
    this.state.updateState({timeZone: event.value});
    this.setStaticChart();
  }

  changeUndersampling(event: MatRadioChange) {
    this.underSampling = event.value;
    this.state.updateState({underSampling: event.value});
  }

  offsetsForUTC() {
    return Array.from({length: 49}, (_, index) => index - 24);
  }

  private getSerieVisibilityById() {

    let seriesById = [];
    this.location.forEach((loc) => {
      if (loc.unit.length > 0) {
        loc.unit.forEach((unit) => {
          seriesById[loc.id + '_' + unit.unit] = unit.selected;
        });
      }
      if (loc.child && loc.child.length > 0) {
        loc.child.forEach((locChild) => {
          if (locChild.unit.length > 0) {
            locChild.unit.forEach((childUnit) => {
              seriesById[locChild.id + '_' + childUnit.unit] = childUnit.selected;
            });
          }
        });
      }
    });
    return seriesById;
  }

  private getUnitFromSerie(serie) {
    return serie.options.id.split('_').splice(1).join('_');
  }

  private setChartSize() {

    let breadCrumb = document.getElementById('breadCrumb');
    let topMenu = document.getElementById('topMenu');
    let topContainer = document.getElementById('topContainer');
    // @ts-ignore
    let treeTarget: HTMLElement = document.getElementsByTagName('app-location-tree')[0];
    let axisTarget = document.getElementById('axisTarget');
    let chartFilter = document.getElementById('chartFilter');
    let footer = document.getElementById('footer');
    let chartTarget = document.getElementById('chartTarget');

    topMenu.style.display = this.isFullScreen ? 'none' : 'block';
    treeTarget.style.position = this.isFullScreen ? 'absolute' : 'relative';
    treeTarget.style.display = this.isFullScreen ? 'none' : 'block';
    axisTarget.style.position = this.isFullScreen ? 'absolute' : 'relative';
    axisTarget.style.display = this.showAxisManager && !this.isFullScreen ? 'block' : 'none';

    let width = this.isFullScreen ? window.innerWidth : window.innerWidth - (this.showAxisManager ? 600 : 300);
    let height = this.isFullScreen
      ?
      (window.innerHeight - chartFilter.offsetHeight - 50)
      :
      (window.innerHeight - chartFilter.offsetHeight - topMenu.offsetHeight - footer.offsetHeight);

    this.locationTreeHeight = height - 26;

    chartTarget.style.width = width - 20 + 'px';
    chartTarget.style.height = height + 'px';

    if (this.chart) {
      this.chart.setSize(width - 20, height);
    } else {
      this.needAdjustChartSize = true;
    }
  }

  private getTitleForChartAxis(unit) {

    let legend: string = 'DEFORMATION';
    let incliType: string[] = ['RADIANCT', 'RADIAN', 'RADIAN-X', 'RADIAN-Y'];
    let speedType: string[] = ['SPEEDMS', 'SPEEDMSCT', 'SPEEDKMHCT', 'SPEEDKMH', 'KNOT', 'KNOTCT', 'MPHCT', 'MPH', 'FTM', 'FTMCT','MILLIMETERPERSECONDS'];
    let deformationType: string[] = ['MICRODEF', 'MICRODEFCT'];
    let deplacementType: string[] = ['MILLIMETERCT', 'MILLIMETER', 'METER', 'METERCT'];
    let rateType: string[] = ['PERCENTAGECT', 'PERCENTAGE'];
    let accelerationType: string[] = ['ACCELERATIONG', 'ACCELERATIONGCT', 'ACCELERATIONMS2CT', 'ACCELERATIONMS2'];
    let volumMassType: string[] = ['HUMIDITY', 'HUMIDITYCT'];
    let angularType: string[] = ['RADIANSPEEDCT', 'RADIANSPEED', 'DEGREESPEEDCT', 'DEGREESPEED'];
    let electroInducType: string [] = ['TESLA', 'TESLACT'];
    let magnetoInducType: string [] = ['GAUSS', 'GAUSSCT'];
    let pressureType: string [] = ['BAR', 'BARCT', 'PASCAL', 'PASCALCT', 'KILOPASCALCT', 'KILOPASCAL'];
    let millionParityType: string [] = ['PERMILLION', 'PERMILLIONCT'];
    let temperatureType: string [] = ['DEGREESCELCIUS', 'TEMPERATURE'];
    let electricStrengthType: string [] = ['ELECTROSTATICFIELD', 'ELECTROSTATICFIELDCT'];
    let massType: string[] = ['KILOGRAM', 'KILOGRAMCT'];
    let accousticType: string[] = ['POWERPERMETERSQUARE', 'POWERPERMETERSQUARECT'];
    let tensionType: string[] = ['VOLT', 'MICROVOLT'];
    let timeType: string[] = ['SEC'];
    let frequencyType: string[] = ['MHZ'];
    let surfaceType: string[] = ['MILLIMETERSQUARE'];
    let undefinedType: string[] = ['UNDEFINED_UNIT'];
    let noType: string[] = ['NOUNIT'];

    if (timeType.includes(unit)) {
      legend = 'SEC';
    }

    if (frequencyType.includes(unit)) {
      legend = 'MHZ';
    }

    if (noType.includes(unit)) {
      legend = 'NOUNIT';
    }

    if (temperatureType.includes(unit)) {
      legend = 'CHART_TEMPERATURE';
    }
    if (speedType.includes(unit)) {
      legend = 'SPEED';
    }
    if (incliType.includes(unit)) {
      legend = 'CHART_INCLINATION';
    }
    if (deformationType.includes(unit)) {
      legend = 'DEFORMATION';
    }
    if (deplacementType.includes(unit)) {
      legend = 'DISPLACEMENT';
    }
    if (rateType.includes(unit)) {
      legend = 'RATE';
    }
    if (accelerationType.includes(unit)) {
      legend = 'ACCELERATION';
    }
    if (volumMassType.includes(unit)) {
      legend = 'VOLUMNMASS';
    }
    if (angularType.includes(unit)) {
      legend = 'ANGULAR_SPEED';
    }
    if (electroInducType.includes(unit)) {
      legend = 'ELECTRO_INDUCTION';
    }
    if (magnetoInducType.includes(unit)) {
      legend = 'MAGNETIC_INDUCTION';
    }
    if (pressureType.includes(unit)) {
      legend = 'PRESSURE';
    }
    if (millionParityType.includes(unit)) {
      legend = 'PARITY_PER_MILLION';
    }
    if (electricStrengthType.includes(unit)) {
      legend = 'ELEC_STRENGTH';
    }
    if (massType.includes(unit)) {
      legend = 'MASS';
    }
    if (accousticType.includes(unit)) {
      legend = 'ACOUSTIC_INTENSITY';
    }
    if (tensionType.includes(unit)) {
      legend = 'TENSION';
    }
    if (surfaceType.includes(unit)) {
      legend = 'CHART_SURFACE';
    }
    if (undefinedType.includes(unit)) {
      legend = 'UNDEFINED_UNIT_TYPE';
    }
    return this.translate.instant(legend) + ' - ' + this.translate.instant(unit);
  }

  showTimerModal() {
    const data = {
      start: this.dateStart.value,
      end: this.dateEnd.value,

    };
    this.matDialog.open(AdvancedDateSettingsComponent, {
      backdropClass: 'backdropBackground',
      height: '120px',
      maxWidth: '',
      data
    }).afterClosed()
      .subscribe(
        (date) => {
          if (date !== undefined) {
            this.dateStart.setValue(date.start);
            this.dateEnd.setValue(date.end);
            this.state.updateState(this.generateCurrentGraphicComponentView());
            this.setStaticChart();
          } else {
            return;
          }
        },
        () => {
          return;
        }
      );
  }

  changeIndex(front: boolean = true) {
    this.currentIndexForLocalStoredView = this.localStorageService.changeIndex(front, this.idProject, this.currentIndexForLocalStoredView);
    this.setViewFromLocalStorage();
    if ((this.router.url !== '/chart/' + this.idProject) && (this.router.url !== '/chart/' + this.idProject + '/view' + this.viewId)) {
      this.router.navigateByUrl('/chart/' + this.idProject);
    }
  }

  buttonDisableForLocalStorageViews(button: number) {
    if (button === 1) {
      if (this.currentIndexForLocalStoredView === -1) {
        return true;
      } else if (this.currentIndexForLocalStoredView !== -1) {
        return this.currentIndexForLocalStoredView === this.localStorageService.getGraphicalComponentViews(this.idProject).length - 1;
      }
    } else if (button === 0) {
      if (this.currentIndexForLocalStoredView === -1) {
        return true;
      } else if ((this.localStorageService.getGraphicalComponentViews(this.idProject).length !== 0) && this.currentIndexForLocalStoredView === 0) {
        return true;
      }
    } else if (button === 2) {
      return this.localStorageService.getGraphicalComponentViews(this.idProject).length <= 0;
    }
  }

  // deleteLocalStorageViews() {
  //   this.localStorageService.deleteViews(this.idProject);
  //   this.localStorageService.getGraphicalComponentViews(this.idProject).length = 0;
  //   this.currentIndexForLocalStoredView = -1;
  //   this.setViewName();
  //   if (this.viewId) {
  //     this.viewNameToDisplay = undefined;
  //   }
  // }
  drawThreshold() {
    this.removeUnknowThresholdInChartView();
    if (!this.thresholdTable || this.thresholdTable.length === 0) {
      this.thresholdActivated = false;
      return;
    }
    const locationsFlatArray: ILocation[] = this.locationsFormatterService.getAllLocationsFlat(this.location);
    for (let i = 0; i < this.thresholdTable.length; i++) {
      const threshold = this.thresholdTable[i];
      const thresholdSerieId = threshold.id;
      const thresholdSerieFromChart: Series = this.chart.get(thresholdSerieId) as Series;
      const thresholdLocation = locationsFlatArray.find((l) => l.id === threshold.project_device_location);
      const seriesIdFromThreshold = thresholdLocation.id + '_' + thresholdLocation.unit[0].unit;
      const seriesFromThreshold = this.data[thresholdLocation.unit[0].unit] ?
        this.data[thresholdLocation.unit[0].unit].find((s) => s.id === seriesIdFromThreshold)
        : null;
      if (!seriesFromThreshold) {
        continue;
      }
      let thresholdStartDate = moment.utc(threshold.start_date).unix() * 1000;
      let thresholdEndDate = moment.utc(threshold.end_date).unix() * 1000;
      const dateStartUTC = _.minBy(seriesFromThreshold.data, 'x').x;
      const dateEndUTC = _.maxBy(seriesFromThreshold.data, 'x').x;
      if (thresholdStartDate > dateEndUTC || thresholdEndDate < dateStartUTC) {
        continue;
      }
      if (thresholdStartDate < dateStartUTC) {
        thresholdStartDate = dateStartUTC;
      }
      if (thresholdEndDate > dateEndUTC) {
        thresholdEndDate = dateEndUTC;
      }
      const dataPoints = [
        {
          'y': threshold.value,
          'x': thresholdStartDate
        },
        {
          'y': threshold.value,
          'x': thresholdEndDate
        }
      ];
      const isThresholdLocationSelected = this.locationSelected.includes(threshold.project_device_location);
      if (isThresholdLocationSelected && !thresholdSerieFromChart) {
        this.chart.addSeries(
          <SeriesLineOptions>{
            type: 'line',
            id: thresholdSerieId,
            name: this.translate.instant('THRESHOLD') + ' ' + threshold.thresholdLevel.name + ' ' + threshold.value + ' ' + thresholdLocation.name,
            data: dataPoints,
            yAxis: thresholdLocation.unit[0].unit,
            visible: this.thresholdActivated,
            color: thresholdLocation.unit[0].color,
            dashStyle: this.dashStyleTypes[threshold.thresholdLevel.id],
            showInNavigator: false,
          }
        );
      } else if (!!thresholdSerieFromChart) {
        thresholdSerieFromChart.setData(dataPoints);
        thresholdSerieFromChart.setVisible(this.thresholdActivated && isThresholdLocationSelected, true);
      }
    }
  }

  private showThreshold() {
    let name = 'Threshold';
    const thresholdValue = parseFloat(this.route.snapshot.paramMap.getAll('thresholdValue')[0]);
    const idLocation = parseInt(this.route.snapshot.paramMap.getAll('idLocation')[0]);
    if (thresholdValue && idLocation) {
      this.showOffset = true;
      const locationsFlatArray: ILocation[] = this.locationsFormatterService.getAllLocationsFlat(this.location);
      const thresholdLocation = locationsFlatArray.find((l) => l.id === parseInt(this.route.snapshot.paramMap.getAll('idLocation')[0]));
      const dataPoints = [
        {
          'y': thresholdValue,
          'x': moment.utc(this.datePickerStart).unix() * 1000
        },
        {
          'y': thresholdValue,
          'x': moment.utc(this.datePickerEnd).unix() * 1000
        }
      ];

      this.chart.addSeries(
        <Highcharts.SeriesLineOptions>{
          type: 'line',
          id: '955666633333',
          name: name,
          data: dataPoints,
          yAxis: thresholdLocation.unit[0].unit,
          visible: true,
          color: 'red',
          showInNavigator: false,
        }
      );
    }
  }

  private removeUnknowThresholdInChartView() {
    const thresholdName = this.translate.instant('THRESHOLD');
    const thresholdSeries = this.chart.series.filter((serie) =>
      serie.name.includes(thresholdName)
    );
    const seriesToRemove = [];
    const thresholdIds = this.thresholdTable ? this.thresholdTable.map((t) => t.id) : [];
    for (let i = 0; i < thresholdSeries.length; i++) {
      const viewSerie = thresholdSeries[i];
      if (!thresholdIds.includes(viewSerie.options.id)) {
        seriesToRemove.push(viewSerie);
      }
    }
    for (const thresholdSerie of seriesToRemove) {
      thresholdSerie.remove();
    }
  }

  private setViewName() {
    if (this.viewId) {
    } else if (this.localStorageService.getGraphicalComponentViews(this.idProject).length > 0) {
      this.viewName = this.localStorageService.getGraphicalComponentViews(this.idProject)[this.currentIndexForLocalStoredView].viewName;
    } else {
      this.viewName = null;
    }
  }

  private setViewFromLocalStorage() {
    if (this.localStorageService.getGraphicalComponentViews(this.idProject).length > 0) {
      const graphicComponentView: GraphicComponentView = this.localStorageService.viewsInLocaleStorage[this.currentIndexForLocalStoredView];
      this.state.setStateFromView(graphicComponentView);
      this.setGraphicComponentView(graphicComponentView);
      this.initChart(true, graphicComponentView.unitCollection);
    }
  }

  private sendViewToLocalStorage(graphicComponentView: GraphicComponentView) {
    let currentView: GraphicComponentView = this.localStorageService.getGraphicalComponentView(this.idProject, this.currentIndexForLocalStoredView);
    if (this.viewId && currentView) {
      currentView.viewName = this.viewName;
    }
    if (JSON.stringify(graphicComponentView) !== JSON.stringify(currentView)) {
      const currentDate = new Date();
      graphicComponentView.viewName = '[view] - ' + currentDate.toLocaleString();
      this.currentIndexForLocalStoredView = this.localStorageService.setGraphicalComponentViews(graphicComponentView, this.currentIndexForLocalStoredView, this.idProject);
      this.setViewName();
    }
  }

  private setTreeLocationSelectedLocations() {
    this.locationSelected = [];
    this.location.forEach((loc) => {
      if (loc.selected && loc.unit.length > 0) {
        this.locationSelected.push(loc.id);
      }
      if (loc.child && loc.child.length > 0) {
        loc.child.forEach((locChild) => {
          if (locChild.selected) {
            this.locationSelected.push(locChild.id);
          }
        });
      }
    });
  }

  private updateAxisSelection() {

    const addSelectedUnits = (_units: Set<string>, locations: any[]) => {
      const _addSelectedUnitsFromSingleLocation = (loc) => {
        if (!loc) {
          return;
        }
        if (loc.selected) {
          loc.unit.forEach((unit: any) => unit.selected ? _units.add(unit.unit) : null);
        }
        if (loc.child) {
          addSelectedUnits(_units, loc.child);
        }
      };
      locations.forEach((loc) => _addSelectedUnitsFromSingleLocation(loc));
    };

    const selectedUnits = new Set<string>();
    addSelectedUnits(selectedUnits, this.location);

    this.unitCollection.forEach(
      (unit) => {
        const visible = selectedUnits.has(unit.unit);
        unit.visible = visible;
        this.updateAxisVisibilityInChart(unit.unit, visible);
      }
    );

  }

  private updateAxisVisibilityInChart(unitKey: string, visible: boolean) {
    const axis: any = this.chart.get(unitKey);
    axis.update({visible});
  }

  private updateSmartOffsetMode(state: State) {
    if (Object.keys(state).length === 0) {    // hack to be fixed (to get rid of seed value of behaviour subject)
      return;
    }
    this.switchLocalStorageViewsMode(!state.smartOffsetModeIsChecked);
    this.showEvents = state.showEvents;
    this.showOffset = state.showOffset;
    this.underSampling = state.underSampling;
    this.isSmartOffsetMode = state.smartOffsetModeIsChecked;
    this.periodSelectedForDataGrouping = state.dataGroupingPeriod;
    if (state.informUser) {
      this.toastr.info(this.translate.instant(state.informUser));
    }
    if (state.reloadChart) {
      this.setStaticChart(false);
    }
  }

  private switchLocalStorageViewsMode(enable: boolean) {
    this.localStorageService = enable && this.allowLocalStorageViewsMode ?
      this.injector.get(LocalStorageViewsService)
      : this.injector.get(LocalStorageViewsNoPersistenceService);
  }

  private generateCurrentGraphicComponentView() {
    let graphicComponentView = new GraphicComponentView();
    graphicComponentView.viewProjectId = this.idProject;
    graphicComponentView.viewName = this.viewName;
    graphicComponentView.locationSelected = this.locationSelected;
    graphicComponentView.datePickerStart = this.getDateStartForGraphicalView();
    graphicComponentView.datePickerEnd = Highcharts.dateFormat('%Y-%m-%dT%H:%M:%S.%LZ', this.dateEnd.value);
    graphicComponentView.showAmplitude = this.showAmplitude;
    graphicComponentView.showAxisManager = this.showAxisManager;
    graphicComponentView.showEvents = this.showEvents;
    graphicComponentView.showOffset = this.showOffset;
    graphicComponentView.showSms = this.showSms;
    graphicComponentView.multiDynamic = this.multiDynamic;
    graphicComponentView.isDynamicView = this.isDynamicView;
    graphicComponentView.isFullScreen = this.isFullScreen;
    graphicComponentView.chartType = this.chartType;
    graphicComponentView.frequencyForDataGrouping = this.frequencyForDataGrouping;
    graphicComponentView.periodSelectedForDataGrouping = this.periodSelectedForDataGrouping;
    graphicComponentView.stepInChart = this.stepInChart;
    graphicComponentView.underSampling = this.underSampling;
    graphicComponentView.opposite = this.opposite;
    graphicComponentView.unitCollection = this.unitCollection;
    graphicComponentView.description = this.viewDescription;
    graphicComponentView.featured = this.viewFeatured;
    graphicComponentView.locations = this.state.get('locations');
    graphicComponentView.thresholdActivated = this.thresholdActivated;
    graphicComponentView.thresholdTable = this.thresholdTable;
    graphicComponentView.timeZone = this.timeZone;
    if (this.isDynamicView) {
      graphicComponentView.locationIdEvent = this.locationIdEvent;
    }

    return graphicComponentView;
  }
}
